<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script lang="ts" setup>
import { computed, unref } from 'vue';
import { useRoute } from 'vue-router';
import { LayoutTypes } from '@/constants/layout';
import Default from './default.vue';
import WithSidebar from './with-sidebar.vue';
import H5 from './h5.vue';
import Pure from './pure.vue';
const route = useRoute();

const layoutComponentMap = new Map([
  [LayoutTypes.Pure, Pure],
  [LayoutTypes.Default, Default],
  [LayoutTypes.WithSidebar, WithSidebar],
  [LayoutTypes.H5, H5]
]);
const layoutType = computed(() => route.meta.layoutType ?? LayoutTypes.Default);
const layout = computed(() => layoutComponentMap.get(unref(layoutType) as LayoutTypes));
</script>

<style lang="less">
.bstar-cookie-info__desc {
  display: inline-block;
}
</style>